import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAdminProject,
  fetchProjectDetails,
  fetchProjectFreelancer,
  fetchProjectUploadeableDetails,
  inviteToProject,
  updateProjectStatus,
  uploadDocumentByAdmin,
} from "../actions/projectAction";

const initialState = {
  isLoading: false,
  isViewProjectDetails: false,
  isInvite: false,
  projectList: {},
  projectData: {},
  deliveableList: []
};

const projectSlice = createSlice({
  name: "admin-projects",
  initialState,
  reducers: {
    setIsViewProjectDetails: (state, action) => {
      state.isViewProjectDetails = action.payload;
    },
    setIsInvite: (state, action) => {
      state.isInvite = action.payload;
    },
  },
  extraReducers: (builder) => {

    // fetchAdminProject
    builder.addCase(fetchAdminProject.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminProject.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.projectList = {
        all: data?.projects || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchAdminProject.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateProjectStatus
    builder.addCase(updateProjectStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateProjectStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateProjectStatus.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-project-details
    builder.addCase(fetchProjectDetails.pending, (state, action) => {

      state.isLoading = true;
    });
    builder.addCase(fetchProjectDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.projectData = data || {};
      state.isViewProjectDetails = true;
      state.isLoading = false;
    });
    builder.addCase(fetchProjectDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-project-freelancer
    builder.addCase(fetchProjectFreelancer.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectFreelancer.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.matchFreelancerList = data?.talents || []
      state.isLoading = false;
    });
    builder.addCase(fetchProjectFreelancer.rejected, (state, action) => {

      state.isLoading = false;
    });

    // updateProjectStatus
    builder.addCase(inviteToProject.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(inviteToProject.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(inviteToProject.rejected, (state, action) => {
      state.isLoading = false;
    });

    // uploadDocumentByAdmin
    builder.addCase(uploadDocumentByAdmin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(uploadDocumentByAdmin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(uploadDocumentByAdmin.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchProjectUploadeableDetails
    builder.addCase(fetchProjectUploadeableDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectUploadeableDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.deliveableList = data?.deliverables || []
      state.isLoading = false;
    });
    builder.addCase(fetchProjectUploadeableDetails.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default projectSlice.reducer;
export const { setIsViewProjectDetails, setIsInvite } = projectSlice.actions;
